import { SendIcon } from "lucide-react";

import { OpenAPI } from "simplydo/interfaces";
import { styled } from "simplydo/react/styled";
import { Button } from "simplydo/react/ui/button";
import { Card, CardContent } from "simplydo/react/ui/card";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Loader } from "simplydo/react/ui/loader";
import { MenuItem } from "simplydo/react/ui/menu";

import { UserChip } from "components/lib/Chips";

import type { MessageRecipient } from "./types";

const RecipientContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

type MessageTraySearchProps = {
  results: MessageRecipient[];
  selectRecipients: (user: MessageRecipient) => void;
  searching: boolean;
  addRecipient: (user: MessageRecipient) => void;
  removeRecipient: (user: MessageRecipient) => void;
  recipients: MessageRecipient[];
  createChat: (userIds: string[]) => void;
};

const MessageTraySearch = ({
  results,
  selectRecipients,
  searching,
  addRecipient,
  removeRecipient,
  recipients,
  createChat,
}: MessageTraySearchProps) => {
  if (searching)
    return (
      <MenuItem>
        <Loader />
      </MenuItem>
    );
  if (!results) return <p>No users found</p>;
  return (
    <>
      {results.slice(0, 9).map((u) => (
        <MenuItem
          key={u._id}
          style={{ display: "flex" }}
          onClick={() => addRecipient(u)}
        >
          {/* Chip popups stopPropagation; keep the row clickable for selection. */}
          <div style={{ pointerEvents: "none" }}>
            <UserChip user={u} />
          </div>
        </MenuItem>
      ))}
      {recipients.length ? (
        <Card fluid>
          <CardContent>
            <H3>Selected recipients</H3>
            <RecipientContainer>
              {recipients.map((u) => (
                <UserChip
                  key={u._id}
                  user={u}
                  compact
                  actionClick={() => removeRecipient(u)}
                />
              ))}
            </RecipientContainer>
            {recipients.length > 1 ? (
              <Button
                fluid
                onClick={() => createChat(recipients.map((u) => u._id))}
                color="primary"
              >
                <Icon icon={SendIcon} />
                Start group chat
              </Button>
            ) : (
              <Button
                fluid
                onClick={() => {
                  const recipient = recipients[0];
                  if (recipient) selectRecipients(recipient);
                }}
                color="primary"
              >
                <Icon icon={SendIcon} />
                Message user
              </Button>
            )}
          </CardContent>
        </Card>
      ) : null}
    </>
  );
};

export default MessageTraySearch;
